var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.isLikingClasses,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleLike.apply(null, arguments)}}},[_c('span',{staticClass:"icon-thumbs-up"}),_vm._v(_vm._s(_vm.likeText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }